import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/superyachttimes.webp';
import screenshot_target from '../../../images/letterfunnel/merijndewaard.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Merijn de Waard"
      firstname="Merijn"
      companyname="SuperYacht Times"
      competition="BOAT International en The Superyacht Group"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/merijndewaard.js